import './CustomCkEditor.scss';

import { MergefloDealspaceUsers } from '@Helper/Interfaces';
import { getPlayBookDetail } from '@Store/feature/playBookDetailSlice';
import { useAppSelector } from '@Store/hooks';
import { Button } from 'devextreme-react/button';
import HtmlEditor, {
  ImageUpload,
  Item,
  MediaResizing,
  Toolbar,
} from 'devextreme-react/html-editor';
import React, { FC, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { RouteEnums } from '@Helper/Enums';

export const tabs = [
  { name: 'From This Device', value: ['file'] },
  { name: 'From the Web', value: ['url'] },
  { name: 'Both', value: ['file', 'url'] },
];

const sizeValues = ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'];
const fontValues = [
  'Arial',
  'Courier New',
  'Georgia',
  'Impact',
  'Lucida Console',
  'Tahoma',
  'Times New Roman',
  'Verdana',
];

const headerValues = [false, 1, 2, 3, 4, 5];

type CustomCkEditorProps = {
  value?: string;
  setValue?: () => void;
  onBlur?: () => void;
  onMouseLeave?: () => void;
  onChange?: (value: string) => void;
  onClose?: (value: string) => void;
  setEditing?: (value: boolean) => void;
  mentions: MergefloDealspaceUsers[];
  height: number;
};

const CustomCkEditor: FC<CustomCkEditorProps> = ({
  value,
  onBlur,
  onMouseLeave,
  onChange,
  setEditing,
  mentions,
  height,
}) => {
  const container = useRef<HTMLDivElement>(null);
  const [currentTab] = useState(tabs[2].value);
  const { dealTaskList } = useAppSelector(getPlayBookDetail);
  const { id, pid, tabNumber } = useParams();
  const [editorValue, setEditorValue] = useState('');
  const containerHtmlEditor = useRef<HtmlEditor>(null);

  const mentionsConfig = [
    {
      dataSource: mentions.map((item, index) => {
        return {
          id: index,
          team: item.surname,
          text: item.name !== '' ? item.name : item.username,
          icon: '',
        };
      }) as any,
      marker: '@',
      searchExpr: ['text', 'team'],
      displayExpr: ({ text, team }: any) => `${text} ${team}`,
      valueExpr: 'id',
      template: ({ value, id }: any) =>
        `<a href="#${id}">@${value}</a><a style='display:none;'>${
          'mentionedUser-' +
          (mentions.find(i => i.name + ' ' + i.surname === value)?.username ===
          undefined
            ? value
            : mentions.find(i => i.name + ' ' + i.surname === value)?.username)
        }~</a>`,
    },
    {
      dataSource: dealTaskList
        ?.filter(item => !item.isArchived)
        ?.filter(item => item.playbookId === pid)
        ?.map((item, index) => {
          return {
            id: item.id,
            team: item.name,
            text: item.itemNumber,
            icon: '',
          };
        }) as any,
      marker: '#',
      searchExpr: ['text', 'team'],
      displayExpr: ({ text, team }: any) => `${text}`,
      valueExpr: 'id',
      template: ({ value }: any) =>
        `<a href="${RouteEnums.Playbook}${id}/${pid}/${tabNumber}?selectedIssue=${value}">#${value}</a>`,
    },
  ];

  const currentChangedValue = (e: any) => {
    // if (containerHtmlEditor.current && !containerHtmlEditor.current.contains(e.target)) {
    //   console.log('ssssssss');
    // }
    // if (e.event.currentTarget.className.includes('ql-blank')) {
    //   setEditorValue('');
    // } else {
    //   setEditorValue(e.event.currentTarget.innerHTML);
    // }
  };

  return (
    <div ref={container} style={{ zIndex: 999999 }}>
      <HtmlEditor
        height={`${height}px`}
        defaultValue={value}
        onInitialized={e => {
          setTimeout(() => {
            e.component?.focus();
            e.element?.focus();
          }, 300);
        }}
        onFocusOut={currentChangedValue}
        mentions={mentionsConfig}
        ref={containerHtmlEditor}
        id="HtmlEditorComponent"
      >
        <MediaResizing enabled={true} />
        <ImageUpload
          tabs={currentTab}
          fileUploadMode="base64"
          uploadDirectory={(e: any) => console.log('uploadDirectory', e)}
        />
        <Toolbar multiline={false}>
          <Item name="separator" />
          <Item name="size" acceptedValues={sizeValues} />
          <Item name="font" acceptedValues={fontValues} />
          <Item name="separator" />
          <Item name="image" />
          <Item name="bold" />
          <Item name="italic" />
          <Item name="strike" />
          <Item name="underline" />
          <Item name="separator" />
          <Item name="alignLeft" />
          <Item name="alignCenter" />
          <Item name="alignRight" />
          <Item name="alignJustify" />
          <Item name="separator" />
          <Item name="orderedList" />
          <Item name="bulletList" />
          <Item name="separator" />
          <Item name="header" acceptedValues={headerValues} />
          <Item name="separator" />
          <Item name="color" />
          <Item name="background" />
          <Item name="separator" />
          <Item name="link" />
        </Toolbar>
      </HtmlEditor>

      <div className="htmlEditorFooter">
        <Button
          width={86}
          style={{ marginRight: 5 }}
          text="Cancel"
          type="danger"
          stylingMode="text"
          onClick={() => {
            setEditing && setEditing(false);
          }}
        />
        <Button
          width={70}
          text="Save"
          type="default"
          stylingMode="contained"
          onClick={() => {
            if (onChange) {
              const v =
                document
                  .getElementById('HtmlEditorComponent')
                  ?.getElementsByClassName('ql-editor dx-htmleditor-content')[0]
                  .innerHTML || '';

              onChange(v);
              setEditing && setEditing(false);
            }
          }}
        />
      </div>
    </div>
  );
};

export default CustomCkEditor;
